import {Engineering} from "@mui/icons-material";
import {Link} from "react-router-dom";

interface IOrganizationsFieldProps {
    organizations: string[][],
    projectOrganizations: {[key:string]:number},
    isProject: boolean,
}
export const OrganizationsField = ({organizations, isProject, projectOrganizations}:IOrganizationsFieldProps) => {
    const showProjectLink = (p:string) => (isProject && projectOrganizations[p] && projectOrganizations[p] > 1) || (!isProject && projectOrganizations[p]);
    return (<p>
        {organizations.map((e, i) => {
            const isLast = i === (organizations.length - 1);
            const link = <Link to={`/search/?TYPE=Project&ORGANIZATION_lead=${e[0]}&from=0&size=10`}>
                <Engineering
                    fontSize={"small"}
                    titleAccess={isProject ? "Find all projects in ELTRP for this organization" : "Find projects in ELTRP for this organization"}/>
            </Link>;
            return <>{e[0]}{e[1] ? ", " + e[1] : ""}{showProjectLink(e[0]) ? link : ""}{isLast ? "" : "; "}</>;
        })}
    </p>)
}
